<!-- Employment History's Table -->
<div class="table-wrapper custom-table">
  <ngx-spinner [fullScreen]="false" id="pacman" type="pacman" [name]="spinnerName"></ngx-spinner>
  <mat-table class="table" matSort matSortActive="createdOn" matSortDirection="desc" matSortDisableClear
    [dataSource]="dataSource">
    <!-- FullName Column -->
    <ng-container matColumnDef="lastName" [sticky]="screenService.isAboveMd$ | async">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'AbsenceName' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element"><a [routerLink]="['/profile', element.WorkerId, 'absences']">{{
          element.FullName }}</a></mat-cell>
    </ng-container>
    <!-- Company Column -->
    <ng-container matColumnDef="company">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'Company' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.Company }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="employer">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'Employer' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.Employer }}</mat-cell>
    </ng-container>
    <!-- EmployerObject Column -->
    <ng-container matColumnDef="employerObject">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'AbsenceObject' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.EmployerObject }}</mat-cell>
    </ng-container>
    <!-- Absence Type Column -->
    <ng-container matColumnDef="absenceType">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'AbsenceType' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.AbsenceType }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="sentToApprovalOn">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'SentToApprovalOn' | translate }} <app-table-header-sort></app-table-header-sort></mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.SentToApprovalOn | date : 'yyyy-MM-dd HH:mm' }}</mat-cell>
    </ng-container>
    <!-- Start Date Column -->
    <ng-container matColumnDef="startDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'AbsencePeriod' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.StartDate | date : 'yyyy-MM-dd' }} - {{ element.EndDate | date :
        'yyyy-MM-dd' }}</mat-cell>
    </ng-container>
    <!-- Business Days Column -->
    <ng-container matColumnDef="businessDays">
      <mat-header-cell *matHeaderCellDef mat-sort-header="BusinessTimeTicks" class="hidden-sort">
        {{ 'Absences.Registry.DaysColumn' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (element.showBusinessTime) {
        {{ element.BusinessTimeTicks | ticksToString : 'dd hh mm' }}
        }
        @if (element.showWorkingTimeTooltip) {
        <div>
          <mat-icon [matTooltip]="'Absences.List.PartTimeInfoTooltip' | translate" matTooltipPosition="above"> info
          </mat-icon>
        </div>
        }
        @if (element.BusinessTimeTicksChanged) {
        <div>
          <mat-icon [matTooltip]="'AbsenceValueChanged' | translate" matTooltipPosition="above"> update </mat-icon>
        </div>
        }
      </mat-cell>
    </ng-container>
    <!-- Working Time Dimension Column -->
    <ng-container matColumnDef="workingTimeDimension">
      <mat-header-cell *matHeaderCellDef class="hidden-sort">
        {{ 'Absences.List.WorkingTimeDimensionColumn' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (element.WorkingTimeNominator !== null && element.WorkingTimeDenominator !== null) {
        {{ element.WorkingTimeNominator }}/{{ element.WorkingTimeDenominator }}
        } @else {
        -
        }
      </mat-cell>
    </ng-container>
    <!-- Absence Reason Column -->
    <ng-container matColumnDef="absenceReason">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'AbsenceComment' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.AbsenceReason }}</mat-cell>
    </ng-container>
    <!-- Status Column -->
    <ng-container matColumnDef="status" [stickyEnd]="screenService.isAboveMd$ | async">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'AbsenceStatus' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div [matTooltip]="element.statusDatesTooltip" matTooltipClass="tooltip-dates" class="status"
          [ngClass]="{ 'status--green': element.StatusId === 3, 'status--yellow': element.StatusId === 2, 'status--red': element.StatusId === 4 }">
          <div class="status__dot"></div>
          @if (element.showProgressSpinner) {
          <app-approval-progress-badge [completedSteps]="element.CompletedApprovalSteps"
            [totalSteps]="element.TotalApprovalSteps" [statusText]="element.Status">
          </app-approval-progress-badge>
          } @else {
          {{ element.Status }}
          }
        </div>
        @if (element.showStatusTooltip) {
        <div>
          <mat-icon [matTooltip]="element.statusTooltip" matTooltipPosition="above"> info </mat-icon>
        </div>
        }
      </mat-cell>
    </ng-container>
    <!-- IsSentToExternalSystem Column -->
    @if (isSentToExternalSystemVisible) {
    <ng-container matColumnDef="isSentToExteralSystem">
      <mat-header-cell *matHeaderCellDef mat-sort-header="ExternalSyncStatusId" class="hidden-sort">
        {{ 'IsSentToExteralSystem' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="sent-to-external-system-icon">
          @if (element.ExternalSyncStatusId === AbsenceSyncStatusEnum.SentToExteralSystem) {
          <mat-icon class="check-circle-icon icon-yellow">access_time_filled</mat-icon>
          } @if (element.ExternalSyncStatusId === AbsenceSyncStatusEnum.ProcessedByExteralSystem) {
          <mat-icon class="check-circle-icon icon-green">check_circle</mat-icon>
          }
        </div>
      </mat-cell>
    </ng-container>
    }
    <!-- Actions Column -->
    <ng-container matColumnDef="actions" stickyEnd>
      <mat-header-cell *matHeaderCellDef> {{ 'Actions' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <ng-container></ng-container>
        @if (element.hasAnyAction) {
        @if (screenService.isAboveMd$ | async) {
        <button mat-button class="button-text" [matMenuTriggerFor]="menuRow">
          <mat-icon class="material-icons-outlined">more_vert</mat-icon>
        </button>
        } @else {
        <button mat-icon-button [matMenuTriggerFor]="menuRow">
          <mat-icon class="material-icons-outlined">more_vert</mat-icon>
        </button>
        }
        }

        <mat-menu #menuRow="matMenu" panelClass="actions-menu">
          @if (!!element.SickLeaveId) {
          <button *ifHasPermissions="['GetMyWorkerSickLeavesDetails', 'GetAllWorkerSickLeavesDetails']" mat-button
            (click)="openDetailsModal(element.SickLeaveId)">
            <mat-icon>visibility</mat-icon>
            <span class="button-text">{{ 'Details' | translate }}</span>
          </button>
          } @if (element.showConfirmAbsence) {
          <button mat-button (click)="confirmAbsence(element.Id)">
            <mat-icon>check_circle</mat-icon>
            <span class="button-text">{{ 'ConfirmAbsence' | translate }}</span>
          </button>
          } @if (element.showSendToApproval) {
          <button mat-button (click)="sendToApproval(element.Id)">
            <mat-icon>send</mat-icon>
            <span class="button-text">{{ 'SendToApproval' | translate }}</span>
          </button>
          } @if (element.showApprovingButtons) { @if (element.showAcceptAbsence) {
          <button mat-button (click)="acceptAbsence(element.Id)"
            *ifHasPermissions="['AcceptWorkerAbsences', 'Supervisor']">
            <mat-icon [svgIcon]="'thumb-up-icon'"></mat-icon>
            <span class="button-text">{{ 'AcceptAbsence' | translate }}</span>
          </button>
          } @if (element.showRejectAbsence) {
          <button mat-button (click)="rejectAbsence(element.Id)"
            *ifHasPermissions="['RejectWorkerAbsences', 'Supervisor']">
            <mat-icon [svgIcon]="'thumb-down-icon'"></mat-icon>
            <span class="button-text">{{ 'RejectAbsence' | translate }}</span>
          </button>
          } } @if (element.showDeleteAbsence) {
          <button mat-button (click)="deleteAbsence(element.Id)"
            *ifHasPermissions="['DeleteMyAbsences', 'DeleteWorkerAbsences']">
            <mat-icon [svgIcon]="'bin-icon'"></mat-icon>
            <span class="button-text">{{ 'DeleteAbsence' | translate }}</span>
          </button>
          } @if (element.showBackToDraftAbsence) {
          <button mat-button (click)="backToDraftAbsence(element.Id)"
            *ifHasPermissions="['BackToDraftMyAbsences', 'BackToDraftWorkerAbsences']">
            <mat-icon [svgIcon]="'close-icon'"></mat-icon>
            <span class="button-text">{{ 'BackToDraftAbsence' | translate }}</span>
          </button>
          } @if (element.showCancelAbsence) {
          <button mat-button (click)="cancelAbsence(element.Id)"
            *ifHasPermissions="['CancelMyWorkersAbsences', 'CancelGlobalWorkersAbsences', 'Supervisor']">
            <mat-icon>reply</mat-icon>
            <span class="button-text">{{ 'CancelAbsence' | translate }}</span>
          </button>
          }
        </mat-menu>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>

<mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"> </mat-paginator>
